import {BlockBuilder} from '../../classes/blockBuilder';
import {BlockType} from '../../classes/blockType';

export const productRecommendations = new BlockType({
  name: 'productRecommendations',
  title: 'Recommended Products',
  compatibility: ['mail'],
  component: () =>
    import(
      /* webpackChunkName: "TmlMailPage" */ './ProductRecommendationsBlock.vue'
    ),
  builder: () =>
    BlockBuilder.create('productRecommendations')
      .property('collectionId', '')
      .property('collectionUrlName', '')
      .property('productCount', '4')
      .property('sortOrder', 'bestsellerOrder')
      .property('showTitle', '1')
      .property('showPrice', '1')
      .property('imageRatio', 'square'),
});
